import { render, staticRenderFns } from "./HubEditPage.vue?vue&type=template&id=4724ae54&"
import script from "./HubEditPage.vue?vue&type=script&lang=js&"
export * from "./HubEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports